export const ICON_MAP_CURRENT = {
  400: 'tstorm',
  401: 'rain',
  402: 'tstorm',
  422: 'tornado',
  429: 'tornado',
  470: 'tstorm',
  471: 'rainwind',
  472: 'tstorm',
  480: 'tstorm',
  481: 'rain',
  482: 'tstorm',
  490: 'tstorm',
  491: 'rainwind',
  492: 'tstorm',
  500: 'rainsnow',
  570: 'rainsnow',
  580: 'rainsnow',
  590: 'rainsnow',
  600: 'hailrain',
  610: 'icy',
  640: 'icy',
  650: 'hailrain',
  660: 'icy',
  670: 'hailrain',
  680: 'icy',
  690: 'hailrain',
  700: 'snowice',
  701: 'snowice',
  705: 'snowice',
  706: 'snowice',
  710: 'snowice',
  711: 'snowice',
  715: 'snowice',
  716: 'snowice',
  720: 'snowice',
  725: 'snowice',
  730: 'snowthunder',
  735: 'snowthunder',
  750: 'snowice',
  751: 'snowice',
  755: 'blowingsnow',
  756: 'snowice',
  760: 'snowice',
  761: 'snowice',
  765: 'snowice',
  766: 'snowice',
  770: 'snowice',
  775: 'snowice',
  780: 'snowthunder',
  785: 'snowthunder',
  800: 'icy',
  801: 'icy',
  802: 'icy',
  810: 'icy',
  815: 'icy',
  820: 'icy',
  825: 'icy',
  870: 'icy',
  871: 'icy',
  872: 'icy',
  880: 'icy',
  881: 'icy',
  882: 'icy',
  890: 'icy',
  891: 'icy',
  892: 'icy',
  900: 'drizzle',
  901: 'drizzle',
  902: 'drizzle',
  910: 'fogdrizzle',
  980: 'fogdrizzle',
  990: 'drizzle',
  991: 'drizzle',
  992: 'drizzle',
  1000: 'icy',
  1001: 'icy',
  1002: 'icy',
  1010: 'icy',
  1040: 'icy',
  1050: 'icy',
  1060: 'icy',
  1070: 'icy',
  1071: 'icy',
  1072: 'icy',
  1080: 'icy',
  1081: 'icy',
  1082: 'icy',
  1090: 'icy',
  1091: 'icy',
  1092: 'icy',
  1100: 'showers',
  1101: 'sctdshowers',
  1102: 'heavyrain',
  1170: 'rainwind',
  1171: 'rainwind',
  1172: 'heavyrain',
  1180: 'fogdrizzle',
  1181: 'fogdrizzle',
  1182: 'heavyrain',
  1190: 'rainwind',
  1191: 'rainwind',
  1192: 'heavyrain',
  1200: 'rain',
  1201: 'showers',
  1202: 'heavyrain',
  1210: 'icy',
  1211: 'icy',
  1212: 'icy',
  1215: 'icy',
  1216: 'icy',
  1217: 'icy',
  1220: 'icy',
  1221: 'icy',
  1222: 'icy',
  1225: 'icy',
  1226: 'icy',
  1227: 'icy',
  1230: 'icy',
  1231: 'icy',
  1232: 'icy',
  1235: 'icy',
  1236: 'icy',
  1237: 'icy',
  1240: 'icy',
  1241: 'icy',
  1242: 'icy',
  1245: 'icy',
  1246: 'icy',
  1247: 'icy',
  1270: 'rainwind',
  1271: 'rainwind',
  1272: 'rainwind',
  1280: 'fogdrizzle',
  1281: 'fogdrizzle',
  1282: 'heavyrain',
  1290: 'rainwind',
  1291: 'rainwind',
  1292: 'rainwind',
  1310: 'flurries',
  1311: 'flurries',
  1312: 'flurries',
  1370: 'flurries',
  1371: 'flurries',
  1372: 'snowshowers',
  1380: 'flurries',
  1381: 'flurries',
  1382: 'snowshowers',
  1390: 'flurries',
  1391: 'flurries',
  1392: 'snowshowers',
  1400: 'snowshowers',
  1401: 'snowshowers',
  1402: 'heavysnow',
  1470: 'blowingsnow',
  1471: 'blowingsnow',
  1472: 'blowingsnow',
  1480: 'snowshowers',
  1481: 'snowshowers',
  1482: 'heavysnow',
  1490: 'blowingsnow',
  1491: 'blowingsnow',
  1492: 'blowingsnow',
  1500: 'blowingsnow',
  1501: 'blowingsnow',
  1509: 'blowingsnow',
  1570: 'blowingsnow',
  1571: 'blowingsnow',
  1579: 'blowingsnow',
  1580: 'blowingsnow',
  1581: 'blowingsnow',
  1589: 'blowingsnow',
  1590: 'blowingsnow',
  1591: 'blowingsnow',
  1599: 'blowingsnow',
  1600: 'snow',
  1601: 'snow',
  1602: 'heavysnow',
  1630: 'snowthunder',
  1631: 'snowthunder',
  1632: 'snowthunder',
  1640: 'snowthunder',
  1641: 'snowthunder',
  1642: 'snowthunder',
  1650: 'snowthunder',
  1651: 'snowthunder',
  1652: 'snowthunder',
  1660: 'snowthunder',
  1661: 'snowthunder',
  1662: 'snowthunder',
  1670: 'snow',
  1671: 'snow',
  1672: 'heavysnow',
  1680: 'blowingsnow',
  1681: 'blowingsnow',
  1682: 'blowingsnow',
  1690: 'blowingsnow',
  1691: 'blowingsnow',
  1692: 'blowingsnow',
  1700: 'hail',
  1701: 'hail',
  1730: 'hail',
  1731: 'hail',
  1740: 'hail',
  1741: 'hail',
  1750: 'hail',
  1751: 'hail',
  1760: 'hail',
  1761: 'hail',
  1770: 'hail',
  1771: 'hail',
  1780: 'hail',
  1781: 'hail',
  1790: 'hail',
  1791: 'hail',
  1800: 'hail',
  1801: 'hail',
  1802: 'hail',
  1810: 'flurries',
  1811: 'snowthunder',
  1816: 'snowthunder',
  1821: 'snowthunder',
  1826: 'snowthunder',
  1830: 'hail',
  1831: 'hail',
  1832: 'hail',
  1840: 'hail',
  1841: 'hail',
  1842: 'hail',
  1850: 'hail',
  1851: 'hail',
  1852: 'hail',
  1860: 'flurries',
  1861: 'flurries',
  1870: 'flurries',
  1880: 'hail',
  1881: 'hail',
  1882: 'hail',
  1885: 'hail',
  1886: 'hail',
  1887: 'hail',
  1890: 'hail',
  1891: 'hail',
  1892: 'hail',
  1895: 'hail',
  1896: 'hail',
  1897: 'hail',
  1900: 'dust',
  1901: 'dust',
  1902: 'dust',
  1910: 'dust',
  1911: 'windy',
  1912: 'windy',
  1919: 'windy',
  1920: 'dust',
  1922: 'dust',
  1929: 'dust',
  1930: 'dust',
  1931: 'dust',
  1932: 'dust',
  1939: 'dust',
  1960: 'dust',
  1961: 'dust',
  1962: 'dust',
  1969: 'dust',
  1970: 'dust',
  1972: 'dust',
  1979: 'dust',
  1980: 'windy',
  1981: 'windy',
  1982: 'windy',
  1989: 'windy',
  1990: 'dust',
  1991: 'dust',
  1992: 'dust',
  2000: 'fog',
  2001: 'fog',
  2002: 'fogdrizzle',
  2021: 'fog',
  2022: 'fog',
  2081: 'fog',
  2082: 'fog',
  2090: 'fog',
  2091: 'fog',
  2092: 'drizzle',
  2100: 'haze',
  2190: 'haze',
  2200: 'smoke',
  2290: 'smoke',
  2410: 'windy',
  2420: 'dust',
  2429: 'dust',
  2430: 'windy',
  2450: 'fog',
  2460: 'fog',
  2470: 'windy',
  2480: 'dust',
  2489: 'dust',
  2490: 'windy',
  2510: 'flurries',
  2570: 'flurries',
  2580: 'flurries',
  2590: 'flurries',
  2600: 'cloudy',
  2680: 'sctdshowers',
  2681: 'fog',
  2685: 'sctdshowers',
  2686: 'sctdshowers',
  2690: 'cloudywindy',
  2700: 'cloudy',
  2780: 'moonshowernight',
  2781: 'moonshowernight',
  2785: 'moonshowernight',
  2786: 'moonshowernight',
  2790: 'cloudywindy',
  2800: 'cloudy',
  2880: 'sunshowerday',
  2881: 'sunshowerday',
  2885: 'sunshowerday',
  2886: 'sunshowerday',
  2890: 'cloudywindy',
  2900: 'partlycloudynight',
  2980: 'moonshowernight',
  2981: 'moonshowernight',
  2985: 'moonshowernight',
  2986: 'moonshowernight',
  2990: 'partlycloudywindynight',
  3000: 'partlycloudyday',
  3080: 'sunshowerday',
  3081: 'sunshowerday',
  3085: 'sunshowerday',
  3086: 'sunshowerday',
  3090: 'partlycloudywindyday',
  3100: 'clearnight',
  3180: 'moonshowernight',
  3181: 'moonshowernight',
  3185: 'moonshowernight',
  3186: 'moonshowernight',
  3190: 'clearwindynight',
  3200: 'sunnyday',
  3280: 'sunshowerday',
  3281: 'sunshowerday',
  3285: 'sunshowerday',
  3286: 'sunshowerday',
  3290: 'sunnywindyday',
  3300: 'clearnight',
  3380: 'moonshowernight',
  3381: 'moonshowernight',
  3385: 'moonshowernight',
  3386: 'moonshowernight',
  3390: 'clearwindynight',
  3400: 'sunnyday',
  3480: 'sunshowerday',
  3481: 'sunshowerday',
  3485: 'sunshowerday',
  3486: 'sunshowerday',
  3490: 'sunnywindyday',
  3540: 'tstorm',
  3549: 'tstorm',
  3570: 'tstorm',
  3579: 'tstorm',
  3580: 'tstorm',
  3589: 'tstorm',
  3590: 'tstorm',
  3599: 'tstorm',
  3840: 'tstorm',
  3849: 'tstorm',
  3870: 'tstorm',
  3879: 'tstorm',
  3880: 'tstorm',
  3889: 'tstorm',
  3890: 'tstorm',
  3899: 'tstorm',
  4400: 'na',
  4470: 'fog',
  4480: 'cloudywindy',
  4490: 'fog',
} as const;

export const ICON_MAP_FORECAST = {
  300: 'tstorm',
  310: 'tstorm',
  400: 'tstorm',
  402: 'tstorm',
  410: 'tstorm',
  412: 'tstorm',
  500: 'rainsnow',
  510: 'rainsnow',
  600: 'hailrain',
  601: 'hailrain',
  610: 'hailrain',
  611: 'hailrain',
  700: 'snowice',
  701: 'snowice',
  710: 'snowice',
  711: 'snowice',
  800: 'icy',
  810: 'icy',
  850: 'icy',
  900: 'drizzle',
  910: 'drizzle',
  950: 'fogdrizzle',
  1000: 'icy',
  1001: 'icy',
  1002: 'icy',
  1010: 'icy',
  1011: 'icy',
  1012: 'icy',
  1051: 'icy',
  1100: 'showers',
  1110: 'rainwind',
  1140: 'tstorm',
  1170: 'tstorm',
  1200: 'rain',
  1201: 'showers',
  1210: 'rainwind',
  1211: 'rainwind',
  1240: 'rain',
  1251: 'fogdrizzle',
  1270: 'rainwind',
  1300: 'flurries',
  1310: 'flurries',
  1400: 'snowshowers',
  1410: 'blowingsnow',
  1600: 'snow',
  1601: 'snow',
  1610: 'blowingsnow',
  1611: 'blowingsnow',
  1651: 'snow',
  1800: 'hail',
  1801: 'hail',
  1810: 'hail',
  1811: 'hail',
  2000: 'fog',
  2010: 'fog',
  2100: 'haze',
  2110: 'haze',
  2600: 'cloudy',
  2610: 'cloudywindy',
  2700: 'cloudy',
  2710: 'cloudywindy',
  2800: 'cloudy',
  2810: 'cloudywindy',
  2900: 'partlycloudynight',
  2910: 'partlycloudywindynight',
  3000: 'partlycloudyday',
  3010: 'partlycloudywindyday',
  3100: 'clearnight',
  3110: 'clearwindynight',
  3200: 'sunnyday',
  3210: 'sunnywindyday',
  3300: 'clearnight',
  3310: 'clearwindynight',
  3400: 'sunnyday',
  3410: 'sunnywindyday',
  3700: 'suntstormday',
  3709: 'moontstormnight',
  3710: 'suntstormday',
  3719: 'moontstormnight',
  3800: 'suntstormday',
  3809: 'moontstormnight',
  3810: 'suntstormday',
  3819: 'moontstormnight',
  3900: 'sunshowerday',
  3909: 'moonshowernight',
  3910: 'sunshowerday',
  3919: 'moonshowernight',
  4000: 'heavyrain',
  4010: 'rainwind',
  4100: 'sunsnowday',
  4109: 'moonsnownight',
  4110: 'sunsnowday',
  4119: 'moonsnownight',
  4200: 'heavysnow',
  4210: 'blowingsnow',
  4300: 'blowingsnow',
  4400: 'na',
  4500: 'drizzle',
  4510: 'drizzle',
  4600: 'sctdshowers',
  4610: 'sctdshowers',
  4700: 'flurries',
  4710: 'blowingsnow',
  4800: 'sunsnowday',
  4809: 'moonsnownight',
  4810: 'sunsnowday',
  4819: 'moonsnownight',
  4900: 'rainsnow',
  4910: 'rainsnow',
  5000: 'blowingsnow',
  5100: 'icy',
  5101: 'icy',
  5110: 'icy',
  5111: 'icy',
  5200: 'snowice',
  5210: 'blowingsnow',
  5300: 'icy',
  5301: 'icy',
  5302: 'icy',
  5310: 'icy',
  5311: 'icy',
  5312: 'icy',
  5351: 'icy',
  5400: 'blowingsnow',
  5409: 'blowingsnow',
  5500: 'rainwind',
  5509: 'rainwind',
  5600: 'snowthunder',
  5610: 'snowthunder',
  5700: 'suntstormday',
  5709: 'moontstormnight',
  5710: 'suntstormday',
  5719: 'moontstormnight',
  6000: 'drizzle',
  6003: 'drizzle',
  6010: 'drizzle',
  6013: 'drizzle',
  6100: 'sctdshowers',
  6103: 'sctdshowers',
  6110: 'showers',
  6113: 'rainwind',
  6140: 'tstorm',
  6143: 'tstorm',
  6170: 'tstorm',
  6173: 'tstorm',
  6200: 'tstorm',
  6203: 'tstorm',
  6210: 'tstorm',
  6213: 'tstorm',
  6300: 'rain',
  6301: 'showers',
  6303: 'rain',
  6304: 'showers',
  6310: 'rainwind',
  6311: 'rainwind',
  6313: 'rainwind',
  6314: 'rainwind',
  6400: 'rainsnow',
  6401: 'rainsnow',
  6403: 'rainsnow',
  6404: 'rainsnow',
  6410: 'rainsnow',
  6411: 'rainsnow',
  6413: 'rainsnow',
  6414: 'rainsnow',
  6500: 'icy',
  6501: 'icy',
  6503: 'icy',
  6504: 'icy',
  6510: 'icy',
  6511: 'icy',
  6513: 'icy',
  6514: 'icy',
  6600: 'icy',
  6603: 'icy',
  6610: 'icy',
  6613: 'icy',
  6700: 'snowice',
  6701: 'snowice',
  6703: 'snowice',
  6704: 'snowice',
  6710: 'snowice',
  6711: 'snowice',
  6713: 'snowice',
  6714: 'snowice',
  6800: 'snowshowers',
  6803: 'snowshowers',
  6810: 'snowshowers',
  6813: 'snowshowers',
  6900: 'snow',
  6901: 'snowshowers',
  6903: 'snow',
  6904: 'snowshowers',
  6910: 'blowingsnow',
  6911: 'blowingsnow',
  6913: 'blowingsnow',
  6914: 'blowingsnow',
  7000: 'drizzle',
  7003: 'drizzle',
  7010: 'drizzle',
  7013: 'drizzle',
  7100: 'showers',
  7103: 'showers',
  7110: 'showers',
  7113: 'rainwind',
  7140: 'tstorm',
  7143: 'tstorm',
  7170: 'tstorm',
  7173: 'tstorm',
  7200: 'tstorm',
  7203: 'tstorm',
  7210: 'tstorm',
  7213: 'tstorm',
  7300: 'rain',
  7301: 'showers',
  7303: 'rain',
  7304: 'showers',
  7310: 'rainwind',
  7311: 'rainwind',
  7313: 'rainwind',
  7314: 'rainwind',
  7400: 'rainsnow',
  7401: 'rainsnow',
  7403: 'rainsnow',
  7404: 'rainsnow',
  7410: 'rainsnow',
  7411: 'rainsnow',
  7413: 'rainsnow',
  7414: 'rainsnow',
  7500: 'icy',
  7501: 'icy',
  7503: 'icy',
  7504: 'icy',
  7510: 'icy',
  7511: 'icy',
  7513: 'icy',
  7514: 'icy',
  7600: 'icy',
  7603: 'icy',
  7610: 'icy',
  7613: 'icy',
  7700: 'snowice',
  7701: 'snowice',
  7703: 'snowice',
  7704: 'snowice',
  7710: 'snowice',
  7711: 'snowice',
  7713: 'snowice',
  7714: 'snowice',
  7800: 'snowshowers',
  7803: 'snowshowers',
  7810: 'blowingsnow',
  7813: 'blowingsnow',
  7900: 'snow',
  7901: 'snowshowers',
  7903: 'snow',
  7904: 'snowshowers',
  7910: 'blowingsnow',
  7911: 'blowingsnow',
  7913: 'blowingsnow',
  7914: 'blowingsnow',
  8000: 'rainsnow',
  8010: 'rainsnow',
  8100: 'icy',
  8110: 'icy',
  8200: 'rainsnow',
  8210: 'rainsnow',
  8300: 'snowice',
  8310: 'snowice',
  8400: 'snowice',
  8410: 'snowice',
  8500: 'icy',
  8510: 'icy',
  8600: 'snowice',
  8610: 'snowice',
  8700: 'snowice',
  8710: 'snowice',
  8800: 'snowice',
  8810: 'snowice',
  8900: 'hailrain',
  8910: 'hailrain',
  9000: 'partlycloudynight',
  9003: 'partlycloudyday',
  9010: 'partlycloudywindynight',
  9013: 'partlycloudywindyday',
  9100: 'fog',
  9103: 'fog',
  9110: 'fog',
  9113: 'fog',
  9200: 'fog',
  9203: 'fog',
  9210: 'fog',
  9213: 'fog',
  9300: 'fog',
  9303: 'fog',
  9310: 'fog',
  9313: 'fog',
  9500: 'snowice',
  9510: 'snowice',
} as const;
